import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-kat-typo",
  templateUrl: "./kat-typo.component.html",
  styleUrls: ["./kat-typo.component.scss"],
})
export class KatTypoComponent implements OnInit {
  colours = [
    {
      swatch: "#111418",
      code: "#111418",
    },
    {
      swatch: "#3240A9",
      code: "#3240A9",
    },
    {
      swatch: "#3137F8",
      code: "#3137F8",
    },
    {
      swatch: "#F4F6F7",
      code: "#F4F6F7",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
